import { Checkbox, FormControlLabel } from '@mui/material'
import { memo } from 'react'

const OneCheckbox = ({
    defaultChecked = false,
    size = 'small',
    colorBox = 'white',
    colorLabel = 'white',
    labelSize = '10px',
    text,
    ...rest
}) => {
    return (
        <FormControlLabel control={
            <Checkbox size={size} sx={{
                '& .MuiSvgIcon-root': { color: colorBox }
            }}
            style={{ paddingTop: 0, paddingBottom: 0, paddingRight: '2px' }}
            {...rest} />
        }
        sx={{
            "& .MuiFormControlLabel-label": {
                color: colorLabel,
                fontSize: labelSize,
                '&.Mui-disabled': {
                    color: "rgba(239, 239, 239, 0.3)"
                }
            }
        }}
        label={text} />
    )
}

export default memo(OneCheckbox)
